import styled from '@emotion/styled'
import * as mixins from 'view/styles/mixins'
import * as constants from 'view/styles/constants'
import { ToggleButtonStrip, ToolbarButton } from 'view/components/buttons'

export const ColumnCopySelectorOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${constants.zIndexBlotterOverlay};
  display: flex;
  justify-content: flex-end;
`

export const ColumnCopySelectorWrapper = styled.div<{ positionY: number | null; positionX: number | null }>`
  position: absolute;
  top: ${props => props.positionY || 0}px;
  left: ${props => props.positionX || 0}px;
  width: 180px;
  max-height: 540px;
  min-height: 70px;
  border-radius: 3px;
  box-shadow: 0 0 30px 0 rgba(68, 76, 95, 0.1);
  padding: 13px 6px;
  font-size: 11px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ColumnCopySelectorTitle = styled.div`
  width: 100%;
  display: flex;
  ${mixins.flexCenterContentCrossAxis};
  font-weight: ${constants.FontWeight.SemiBold};
  color: ${constants.CORE_PRIMARY_7};
  flex: 0 0 19px;
  padding: 0 9px;
`

export const ColumnList = styled.ol`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid ${constants.CORE_PRIMARY_1};
`

export const ColumnItem = styled.li<{ indent: boolean; disabled: boolean }>`
  pointer-events: ${props => (props.disabled ? 'none' : 'all')};
  width: 100%;
  height: 26px;
  ${mixins.flexCenterContentCrossAxis};
  padding: 5px;
  padding-left: ${props => (props.indent ? '23px' : '5px')};
  border-radius: 3px;

  &:hover {
    background-color: #eef0f2;
  }

  & label {
    font-size: 11px;
    color: ${constants.CORE_PRIMARY_6};
  }
`

export const ColumnCopySelectorStrip = styled(ToggleButtonStrip)`
  margin-right: 20px !important;
`

export const CopyButton = styled(ToolbarButton)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`

export const DeltaIconContainer = styled.span`
  ${mixins.deltaLabel};
`
